import { useQuery } from "@lookiero/messaging-react";
import { isUiSettingRemoved } from "../../../../domain/uiSetting/model/uiSettingRemoved";
import { isUiSettingUpdated } from "../../../../domain/uiSetting/model/uiSettingUpdated";
import { viewUiSettingByKey } from "../../../../projection/uiSetting/viewUiSettingByKey";
const shouldInvalidate = (event) => isUiSettingUpdated(event) || isUiSettingRemoved(event);
const useViewUiSettingByKey = ({ contextId, key }) => useQuery({
    query: viewUiSettingByKey({ key }),
    contextId,
    invalidation: shouldInvalidate,
    options: {
        refetchOnMount: "always",
        staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
    },
});
export { useViewUiSettingByKey };
